// src/components/themes/default/store/branch/BranchHeroBanner.tsx
"use client";

import { Sparkles, ShoppingBag } from "lucide-react";

interface BranchHeroBannerProps {
  branchName?: string;
  primaryColor?: string;
}

export default function BranchHeroBanner({
  branchName = "Outlet Store",
  primaryColor = "#059669",
}: BranchHeroBannerProps) {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-4 sm:pt-6">
      <div
        style={{
          background: `linear-gradient(135deg, ${primaryColor}18 0%, #ffffff 100%)`,
          borderColor: `${primaryColor}30`,
        }}
        className="rounded-3xl border p-6 sm:p-10 relative overflow-hidden shadow-xs flex flex-col sm:flex-row items-center justify-between gap-6"
      >
        <div className="space-y-3 text-center sm:text-left z-10 max-w-xl">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/90 border border-slate-200 text-slate-700 text-[11px] font-black uppercase tracking-wider shadow-2xs">
            <Sparkles className="w-3.5 h-3.5 text-amber-500" />
            <span>Official Local Outlet</span>
          </div>

          <h2 className="text-2xl sm:text-4xl font-black text-slate-900 leading-tight">
            Exclusive Deals at <span style={{ color: primaryColor }}>{branchName}</span>
          </h2>

          <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
            Order fresh items directly from our verified branch inventory with instant local pickup and fast doorstep delivery.
          </p>
        </div>

        <div className="shrink-0 flex items-center justify-center">
          <div
            style={{ backgroundColor: `${primaryColor}20`, color: primaryColor }}
            className="w-24 h-24 sm:w-28 sm:h-28 rounded-3xl flex items-center justify-center shadow-inner"
          >
            <ShoppingBag className="w-12 h-12 stroke-[1.75]" />
          </div>
        </div>
      </div>
    </section>
  );
}